// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-root {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
}

.app-shell {
  display: flex;
  width: 100%;
  height: 100vh;
}
.app-shell.with-shell ::ng-deep app-header {
  display: none;
}
.app-shell.with-shell ::ng-deep app-home-footer {
  display: none;
}

.app-main {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  height: 100vh;
}

.app-content {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.version {
  position: absolute;
  bottom: 4px;
  right: 4px;
  margin: 0;
  color: #ccc;
  font-size: 0.9rem;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,aAAA;AACF;AAGI;EACE,aAAA;AADN;AAII;EACE,aAAA;AAFN;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;AAJF;;AAOA;EACE,OAAA;EACA,aAAA;EACA,gBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;AAJF","sourcesContent":[".app-root {\n  display: block;\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.app-shell {\n  display: flex;\n  width: 100%;\n  height: 100vh;\n\n  &.with-shell {\n    // When shell is active, hide Ionic's header if any page still renders one\n    ::ng-deep app-header {\n      display: none;\n    }\n    // Hide home-footer since nav is in icon-rail\n    ::ng-deep app-home-footer {\n      display: none;\n    }\n  }\n}\n\n.app-main {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n  height: 100vh;\n}\n\n.app-content {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.version {\n  position: absolute;\n  bottom: 4px;\n  right: 4px;\n  margin: 0;\n  color: #ccc;\n  font-size: 0.9rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
